import { createActions } from 'redux-actions';

import types from 'state/editLog/actionTypes';

const { editLog } = createActions({
  [types.SET_LOG]: ({ log }) => ({ log }),
});

export default editLog;
